<template>
  <div id="RequestFormList">
    <section v-if="!isPrintModalActive">
      <div id="container-center">
        <div class="labelTitle lable">検査申請一覧</div>
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>受付<br>番号</th>
              <td><input type="text" v-model="searchConditions.receiptNumber"/></td>
              <th>種別</th>
              <td><select v-model="searchConditions.kind">
                <option></option>
                <option v-for="kind in kindList" :key="kind.label" :value="kind.value">{{kind.label}}</option>
              </select></td>
              <th>進捗<br>状況</th>
              <td><select v-model="searchConditions.progress">
                <option></option>
                <option v-for="item in progressList" :key="item.code" :value="item.code">{{item.name}}</option>
              </select></td>
              <th>医療機関名</th>
              <td><input type="text" v-model="searchConditions.hospital"/></td>
            </tr>
            <tr>
              <th>診察券ID</th>
              <td><input type="text" v-model="searchConditions.patientId"/></td>
              <th>患者名</th>
              <td><input type="text" v-model="searchConditions.patientName"/></td>
              <th>報告書ダウンロード</th>
              <td><select v-model="searchConditions.downloadFlag"><option value=""></option><option value="0">未</option><option value="1">済</option></select></td>
            </tr>
            <tr>
              <th>申込日</th>
              <td colspan="3"><input type="date" style="width:200px" v-model="searchConditions.applicationDateStart"/> ～ <input type="date" style="width:200px" v-model="searchConditions.applicationDateEnd"/></td>
              <th>完了日</th>
              <td colspan="3"><input type="date" style="width:200px" v-model="searchConditions.completionDateStart"/> ～ <input type="date" style="width:200px" v-model="searchConditions.completionDateEnd"/></td>
            </tr>
          </table>
          <div class="searchButton-area">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
            <b-button class="backbutton is-primary" @click="back">戻る</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area" v-if="data.length > 0">
          <div>
            <span class="result-count">件数：{{data.length}}件</span>
            <b-table
              id="requestFormListTable"
              :data="data"
              :paginated="isPaginated"
              per-page="100"
              pagination-position="both"
              default-sort="receiptNumber"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
              aria-page-label="Page"
              aria-current-label="Current page"
            >
              <template slot-scope="props">
                <b-table-column field="receiptNumber" label="受付番号" width="120" centered sortable>
                  <a @click="showDetail(props.row.detailKind, props.row.progress,props.row)">{{props.row.receiptNumber}}</a>
                  <span v-if="props.row.depositMachineFlag" class="depo"/>
                </b-table-column>
                <b-table-column field="kind" label="種別" width="100" sortable>{{props.row.kind}}</b-table-column>
                <b-table-column field="instrumentKind" label="機種" width="180" sortable >{{props.row.instrumentKind}}</b-table-column>
                <b-table-column field="hospital" label="医療機関名" width="180" sortable>{{props.row.hospital}}</b-table-column>
                <b-table-column field="patientId" label="診察券ID" width="80" sortable>{{props.row.patientId}}</b-table-column>
                <b-table-column field="patientName" label="患者名" width="130" sortable>{{props.row.patientName}}</b-table-column>
                <b-table-column field="progress" label="進捗状況" width="100" centered sortable>
                  <span :class="getTabClass4RequestStatus(props.row.progress)">
                    {{getProgres(props.row.progress)}}
                  </span>
                </b-table-column>
                <b-table-column field="applicationDate" label="申込日" width="80" centered sortable>{{props.row.applicationDate }}</b-table-column>
                <b-table-column field="completionDate" label="完了日" width="80" centered sortable>{{ props.row.completionDate }}</b-table-column>
                <b-table-column label="申込印刷" width="80" centered>
                  <a @click="printDetail(props.row.detailKind,props.row)">
                  <b-icon icon="printer"/></a>
                </b-table-column>
                <b-table-column label="報告書" width="60" centered  sortable>
                  <template v-if="props.row.detailKind.indexOf('企業検診')==-1 && (props.row.progress==13 || props.row.progress==14 || props.row.progress==15 || props.row.progress==18)">
                    <a v-if="props.row.historystatus != 103" @click="showReportArea(props.row)"><b-icon icon="clipboard-file-outline" /></a>
                    <span v-if="showDownloadMark(props.row.reportFileList) && props.row.historystatus != 103" class="download"></span>
                  </template>
                </b-table-column>
                <b-table-column label="問い合わせ" width="80" centered>
                  <a :href=props.row.ref>
                    <b-icon icon="email-outline"/></a></b-table-column>
              </template>
            </b-table>
          </div>
          <div>
            <b-button class="backbutton is-primary" @click="back">戻る</b-button>
          </div>
        </div>
        <div class="result-area" v-if="dataBlank && data.length == 0">
          <div class="result-count">件数：{{data.length}}件</div>
        </div>
      </div>
      <floatingDiv v-if="isShowHstDetail" @close="closeDetail" title="" width="800px" height="480px" :top="dialogTopPostion" right="100px">
        <template v-if="isHospital && isComplete">
          <div id="item-contens">
            <div class="card-content margin-top">
              <table>
                <tr>
                  <th>AHI</th>
                  <td>
                    {{ showDetailTargetData.ahi }}
                  </td>
                </tr>
              </table>
            </div>
            <div class="card-content margin-top printMargin printBreakInside">
              <table>
                <tr>
                  <th>継続申請</th>
                  <td>
                    <b-button v-if="!(isSP()) && isEnableService(serviceId, service.hst)" class="is-primary button-group" style="text-align:right;" @click="requestHst('hst')">睡眠宅配検査</b-button>
                    <b-button v-if="!(isSP()) && isEnableService(serviceId, service.psg)" class="is-primary button-group" style="text-align:right;" @click="requestFullPsg('hst')">フルPSG解析</b-button>
                    <b-button v-if="isEnableService(serviceId, service.cpap)" class="is-primary button-group" style="text-align:right;" @click="requestCpap('hst')">CPAP処方</b-button>
                  </td>
                </tr>
                <tr>
                  <th>施設紹介</th>
                  <td>
                    <b-button v-if="!(isSP())" class="is-primary button-group" style="text-align:right;" @click="introduceHst('hst')">睡眠宅配検査取扱施設</b-button>
                    <b-button v-if="!(isSP())" class="is-primary button-group" style="text-align:right;" @click="introducePsg('hst')">フルPSG実施施設</b-button>
                    <b-button class="is-primary button-group" style="text-align:right;" @click="introduceCpap('hst')">CPAP治療施設</b-button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </template>
        <hstRequestDetail :data="showDetailTargetData" :requestCancel="requestCancel" @cancel="doCancel"/>
      </floatingDiv>
      <floatingDiv v-if="isShowPsgDetail" @close="closeDetail" title="" width="640px" height="480px" :top="dialogTopPostion" right="100px">
        <template v-if="isHospital && isComplete">
          <div id="item-contens">
            <div class="card-content margin-top">
              <table>
                <tr>
                  <th>AHI</th>
                  <td>
                    {{ showDetailTargetData.ahi }}
                  </td>
                </tr>
              </table>
            </div>
            <div class="card-content margin-top printMargin printBreakInside">
              <table>
                <tr>
                  <th>継続申請</th>
                  <td>
                    <b-button v-if="!showDetailTargetData.fullFlag && isEnableService(serviceId, service.hst)" class="is-primary button-group" style="text-align:right;" @click="requestHst('psg')">睡眠宅配検査</b-button>
                    <b-button v-if="isEnableService(serviceId, service.psg)" class="is-primary button-group" style="text-align:right;" @click="requestFullPsg('psg')">フルPSG解析</b-button>
                    <b-button v-if="isEnableService(serviceId, service.cpap)" class="is-primary button-group" style="text-align:right;" @click="requestCpap('psg')">CPAP処方</b-button>
                  </td>
                </tr>
                <tr>
                  <th>施設紹介</th>
                  <td>
                    <b-button v-if="!showDetailTargetData.fullFlag" class="is-primary button-group" style="text-align:right;" @click="introduceHst('psg')">睡眠宅配検査取扱施設</b-button>
                    <b-button v-if="!showDetailTargetData.fullFlag" class="is-primary button-group" style="text-align:right;" @click="introducePsg('psg')">フルPSG実施施設</b-button>
                    <b-button class="is-primary button-group" style="text-align:right;" @click="introduceCpap('psg')">CPAP治療施設</b-button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </template>
        <psgRequestDetail :key="reset" :data="showDetailTargetData" :canUpdate="canUpdate" v-on:reSearch="reSearch" @finish-psg="updateShowDetail" :requestCancel="requestCancel" @cancel="doCancel"/>
      </floatingDiv>
      <floatingDiv v-if="isShowKenshinDetail" @close="closeDetail" title="" width="900px" height="480px" :top="dialogTopPostion" right="100px">
        <kenshinRequestDetail :data="showDetailTargetData"/>
      </floatingDiv>
      <floatingDiv v-if="isShowHolterDetail" @close="closeDetail" title="" width="900px" height="480px" :top="dialogTopPostion" right="100px">
        <template v-if="isHospital && isComplete">
          <div id="item-contens">
            <div class="card-content margin-top printMargin printBreakInside">
              <table>
                <tr>
                  <th>継続申請</th>
                  <td>
                    <b-button v-if="isEnableService(serviceId, service.hst)" class="is-primary" style="text-align:right;" @click="requestHst('holter')">睡眠宅配検査</b-button>
                    <b-button v-if="isEnableService(serviceId, service.psg)" class="is-primary" style="text-align:right;" @click="requestPsg('holter')">簡易PSG解析</b-button>
                    <b-button v-if="isEnableService(serviceId, service.psg)" class="is-primary" style="text-align:right;" @click="requestFullPsg('holter')">フルPSG解析</b-button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </template>
        <holterRequestDetail :data="showDetailTargetData" :requestCancel="requestCancel" @cancel="doCancel" :isHideAnalysisOptions="true"/>
      </floatingDiv>
      <floatingDiv v-if="isShowHolterAnalysisDetail" @close="closeDetail" title="" width="900px" height="480px" :top="dialogTopPostion" right="100px">
        <template v-if="isHospital && isComplete">
          <div id="item-contens">
            <div class="card-content margin-top printMargin printBreakInside">
              <table>
                <tr>
                  <th>継続申請</th>
                  <td>
                    <b-button v-if="isEnableService(serviceId, service.hst)" class="is-primary" style="text-align:right;" @click="requestHst('holterAnalysis')">睡眠宅配検査</b-button>
                    <b-button v-if="isEnableService(serviceId, service.psg)" class="is-primary" style="text-align:right;" @click="requestPsg('holterAnalysis')">簡易PSG解析</b-button>
                    <b-button v-if="isEnableService(serviceId, service.psg)" class="is-primary" style="text-align:right;" @click="requestFullPsg('holterAnalysis')">フルPSG解析</b-button>
                  </td>
                  <tr>
                </tr>
              </table>
            </div>
          </div>
        </template>
        <holterAnalysisRequestDetail :key="reset" :data="showDetailTargetData" :canUpdate="canUpdate" v-on:reSearch="reSearch" @finish-analysis="updateShowDetail" :requestCancel="requestCancel" @cancel="doCancel"/>
      </floatingDiv>
      <template v-if="isHospital">
        <floatingDiv
          v-if="isDownLoadFileList"
          class="file-dialog"
          width="450px"
          height="300px"
          :top="dialogTopPostion"
          right="100px"
          @close="closeDownLoadFileList"
        >
          <FileListHospitalDialog :targetRowData="targetRowData" @download="download" @showDetail="showDetail"/>
        </floatingDiv>
      </template>
      <template v-else>
        <floatingDiv v-if="isDownLoadFileList" @close="closeDownLoadFileList" title="" width="450px" height="300px" :top="dialogTopPostion" right="100px">
          <downLoadFileList :fileList="fileListStr" :showNoteFlg="true" @download="download"/>
        </floatingDiv>
      </template>
    </section>
    <section v-else-if="isPrintModalActive" class="printTarget" style="width:100%;">
      <div id="container-center">
        <h1 class="title has-text-centered printTarget">{{printTitle}}</h1>
        <div>
          <b-button class="is-primary unPrintTarget" style="text-align:right;" @click="isPrintModalActive=false">戻る</b-button>
          <b-button class="is-primary unPrintTarget" style="text-align:right;" icon-left="printer" @click="print">印刷</b-button>
          <section class="printTarget printMargin">
            <div id="item-contens">
              <div class="card-content margin-top">
                <table>
                  <tr><th>受付日時</th><td>{{printTargetReqDate}}</td></tr>
                  <tr><th>受付番号</th><td>{{printTargetReceiptNumber}}</td></tr>
                </table>
              </div>
            </div>
          </section>
          <hstRequestDetail v-if="printType=='HST'" class="printTarget" v-bind:data="printTargetData"/>
          <psgRequestDetail v-else-if="printType=='PSG'" class="printTarget" v-bind:data="printTargetData"/>
          <kenshinRequestDetail v-else-if="printType=='企業検診'" class="printTarget" v-bind:data="printTargetData" v-bind:isAccommodations="isAccommodations" v-bind:isPrint="true"/>
          <holterRequestDetail v-else-if="printType=='Holter'" class="printTarget" v-bind:data="printTargetData" :isHideAnalysisOptions="true"/>
          <holterAnalysisRequestDetail v-else-if="printType=='Analysis'" class="printTarget" v-bind:data="printTargetData"/>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import {choicesType} from "@/components/mock/base/const.js";
import {role} from "@/components/mock/base/const.js";
import {service} from "@/components/mock/base/const.js";
import {requestStatus} from "@/components/mock/base/const.js";
import floatingDiv from "@/components/mock/common/FloatingDiv";
import HSTRequestDetail from "@/components/mock/common/HSTRequestDetail";
import PSGRequestDetail from "@/components/mock/common/PSGRequestDetail";
import HolterRequestDetail from "@/components/mock/common/HolterRequestDetail";
import HolterAnalysisRequestDetail from "@/components/mock/common/HolterAnalysisRequestDetail";
import KenshinRequestDetail from "@/components/mock/common/KenshinRequestDetail";
import DownLoadFileList from "@/components/mock/common/DownLoadFileList";
import FileListHospitalDialog from "./components/FileListHospitalDialog.vue";

export default {
  name: "RequestFormList",
  methods: {
    back: function() {
      this.$router.go(-1);
    },
    reSearch: function() {
      this.reSearchFlag = true
      this.doSearch()
      },
    doSearch: function() {
      var excuteApi = this.getApplicationListPOST;
      var successCallBack = this.getApplicationListPOSTSuccess;
      var errorCallBack = this.getApplicationListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getApplicationListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      obj.kind = obj.kind.length!=0 ? JSON.parse(obj.kind) : []
      obj.progress = obj.progress.length!=0 ? JSON.parse(obj.progress) : []
      obj.belongsId = this.belongsId
      return client.apis.externalRequestSearch.getApplicationListPOST({
        body:obj
      });
    },
    getApplicationListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj

      var subject = encodeURI("【Philips Care Portal】<ここに件名を記載してください>")
      for(var item of this.data){
        var body = encodeURI(
          "\n"
          + "【受付番号】" + item.receiptNumber +"\n"
          + "【医療機関】" + this.escapeStringForMailTo(item.hospital) +"\n"
          + "【検査種別】" + item.kind +"\n"
          + "\n"
          + "【お問い合わせ内容】\n"
          + "\n"
          + "<ここにお問い合わせ内容を記載してください。>\n"
        );
        item.ref = "mailto:"+ item.inqueryAddress + "?subject="+subject+"&body="+body;
      }
      if(this.reSearchFlag){
        var newTarget = this.data.find(val => {return val.receiptNumber == this.showDetailTargetReceiptNumber})
        if(newTarget){
          this.showDetail(newTarget.kind, newTarget.progress, newTarget)
          this.reset += 1;
        }
        this.reSearchFlag = false
      }
      this.dataBlank = true;
    },
    getApplicationListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    showDetail: function(kind, progress, rowData) {
      this.showDetailTargetReceiptNumber = rowData.receiptNumber
      this.showDetailTargetData = rowData.applicationDetails
      this.isComplete = this.completedStatus.includes(progress);
      // 再検査理由表示用    
      this.showDetailTargetData.externalOperation = true;
      this.showDetailTargetData.progress = progress;
      this.showDetailTargetData.receiptNumber = rowData.receiptNumber;
      this.showDetailTargetData.orderType = rowData.detailKind;
      this.showDetailTargetData.depositMachineFlag = rowData.depositMachineFlag;

      this.requestCancel = false
      this.closeDetail();
      this.dialogTopPostion = (100 + window.scrollY) + 'px';
      if(kind.indexOf('HST') >= 0) {
        var today = this.yyyy_sla_MM_sla_dd(new Date())
        today = Number(today.replace(/[/]/g, ''))
        var shippDay = Number(rowData.desiredShippingDate.replace(/[/]/g, ''))
        this.requestCancel = [1,2,3].indexOf(rowData.progress) != -1 && !rowData.reExaminationFlag && today < shippDay
        this.version = rowData.version
        this.isShowHstDetail = true;
      } else if(kind.indexOf('PSG') >= 0){
        this.requestCancel = [7,8,9].indexOf(rowData.progress) != -1
        this.version = rowData.version
        if(progress == 6 || progress == 7 || progress == 100){
          this.canUpdate = true;
        } else {
          this.canUpdate = false;
        }
        this.isShowPsgDetail = true;
      } else if(kind.indexOf('企業検診') >= 0)  {
        this.isShowKenshinDetail = true;
      } else if(kind.indexOf('Holter') >= 0)  {
        var today = this.yyyy_sla_MM_sla_dd(new Date())
        today = Number(today.replace(/[/]/g, ''))
        var shippDay = Number(rowData.desiredShippingDate.replace(/[/]/g, ''))
        this.requestCancel = [1,2,3].indexOf(rowData.progress) != -1 && !rowData.reExaminationFlag && today < shippDay
        this.version = rowData.version
        this.isShowHolterDetail = true;
      } else if(kind.indexOf('Analysis') >= 0)  {
        if(progress == 6 || progress == 7 || progress == 100){
          this.canUpdate = true;
        } else {
          this.canUpdate = false;
        }
        this.isShowHolterAnalysisDetail = true;
      }
      
    },
    updateShowDetail: function() {
      var _this = this;

      this.apiCall(
        function(client){
          return client.apis.externalRequestSearch.getApplicationListPOST({
            body:{receiptNumber: _this.showDetailTargetReceiptNumber}
          });
        },
        function(result){
          if (result.obj.length > 0) {
            var index = _this.data.findIndex(row => {
              return row.receiptNumber == _this.showDetailTargetReceiptNumber
            })

            _this.data.splice(index, 1, result.obj[0])
            _this.canUpdate = false;
          }
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );

    },
    closeDetail: function(){
      this.isShowHstDetail = false;
      this.isShowPsgDetail = false;
      this.isShowKenshinDetail = false;
      this.isShowHolterDetail = false;
      this.isShowHolterAnalysisDetail = false;
    },
    closeDownLoadFileList: function(){
      this.isDownLoadFileList = false;
    },
    showReportArea: function(rowData) {
      this.dialogTopPostion = (100 + window.scrollY) + 'px';
      this.fileListStr = rowData.reportFileList;
      this.targetRowData = rowData;
      this.isDownLoadFileList = true;
    },
    download: function(fileId, downloadFlag) {
      if (this.fileListStr.length > 0) {
        var i = this.fileListStr.findIndex(file => file.fileId == fileId);
        if (i >= 0) {
          var updfile = JSON.parse(JSON.stringify(this.fileListStr[i]))
          updfile.downloadFlag = downloadFlag;
          this.fileListStr.splice(i, 1, updfile)
        }
      }
    },
    printDetail: function(kind, rowData) {
      this.closeDetail();
      this.closeDownLoadFileList();
      this.printTargetReceiptNumber = rowData.receiptNumber
      this.printTargetReqDate = rowData.applicationDatePrint
      this.printTargetData = rowData.applicationDetails
      this.printType = kind
      this.isAccommodations = false
      switch(kind){
        case "HST":
          this.printTitle = "睡眠検査機器配送ｻｰﾋﾞｽ（解析結果付）申込み"
          break;
        case "PSG":
          if(rowData.applicationDetails.fullFlag){
            this.printTitle = "解析申込み（フルPSG検査）"
          }else{
            this.printTitle = "解析申込み（簡易検査）"
          }
          break;
        case "企業検診":
          if(rowData.kind.indexOf("スクリーニング") != -1){
            this.printTitle = "スクリーニング検査申込み"
            this.isAccommodations = true
          }else{
            this.printTitle = "企業検診申込み"
          }
          break;
        case "Holter":
          this.printTitle = "ホルター心電図配送ｻｰﾋﾞｽ"
          break;
        case "Analysis":
          this.printTitle = "ホルター心電図解析ｻｰﾋﾞｽ"
          break;
      }      
      this.isPrintModalActive = true
      this.goToTop()
    },
    print: function() {
      window.print();
    },
    showDownloadMark: function(filelist) {
      if (filelist && filelist.length > 0) {
        var target = filelist.find(file => file.downloadFlag)
        if (target) {
          return true
        }
      }
      return false
    },
    reInspection: function() {
      this.showDetailTargetData
    },
    requestHst: function(kind) {
      this.$router.push({ name: "HSTRequest",params:{receiptNumber:this.showDetailTargetReceiptNumber,kind:kind} });
    },
    requestFullPsg: function(kind) {
      this.$router.push({ name: "PSGRequest", params:{id:'full',receiptNumber:this.showDetailTargetReceiptNumber,kind:kind} });
    },
    requestPsg: function(kind) {
      this.$router.push({ name: "PSGRequest", params:{id:'easy',receiptNumber:this.showDetailTargetReceiptNumber,kind:kind} });
    },
    requestCpap: function(kind) {
      this.$router.push({ name: "CpapRequest", params:{receiptNumber:this.showDetailTargetReceiptNumber,kind:kind} });
    },
    introduceHst: function(kind) {
      // 紹介先選択
      this.$router.push({ name: "IntroductionRequest",params:{prekind: kind, kind:'hst',receiptNumber:this.showDetailTargetReceiptNumber,item:this.showDetailTargetData,searchConditions:this.searchConditions} });
    },
    introducePsg: function(kind) {
      // 紹介先選択
      this.$router.push({ name: "IntroductionRequest",params:{prekind: kind, kind:'psg',receiptNumber:this.showDetailTargetReceiptNumber,item:this.showDetailTargetData,searchConditions:this.searchConditions} });
    },
    introduceCpap: function(kind) {
      // 紹介先選択
      this.$router.push({ name: "IntroductionRequest",params:{prekind: kind, kind:'cpap',receiptNumber:this.showDetailTargetReceiptNumber,item:this.showDetailTargetData,searchConditions:this.searchConditions} });
    },
    isSP: function() {
      var model = this.hstModelList.find(val => val.value == this.showDetailTargetData.model)
      if(model && model.label1 && model.label1.match(/スリーププロファイラー/)){
        return true
      }
      return false
    },
    doCancel:  function(type, reason){
      // 検査をキャンセル
      this.reason = reason
      var excuteApi
      var successCallBack = this.setCancelPOSTSuccess;
      var errorCallBack = this.setCancelPOSTError;
      switch(type){
        case "HST":
          excuteApi = this.setHstCancelPOST;
          break;
        case "PSG":
          excuteApi = this.setPsgCancelPOST;
          break;
        case "Holter":
          excuteApi = this.setHolterCancelPOST;
          break;
      }
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHstCancelPOST: function(client) {
      var reqParam = {
        receiptNumber:this.showDetailTargetReceiptNumber,
        version:this.version,
        reason:this.reason
      }
      return client.apis.externalHst.setHstCancelPOST({
        body:reqParam
      });
    },
    setPsgCancelPOST: function(client) {
      var reqParam = {
        receiptNumber:this.showDetailTargetReceiptNumber,
        version:this.version,
        reason:this.reason
      }
      return client.apis.externalPsg.setPsgCancelPOST({
        body:reqParam
      });
    },
    setHolterCancelPOST: function(client) {
      var reqParam = {
        receptionNo:this.showDetailTargetReceiptNumber,
        version:this.version,
        reason:this.reason
      }
      return client.apis.internalHolter.setHolterReceptionInspectionCancelPOST({
        body:reqParam
      });
    },
    setCancelPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.doSearch()
    },
    setCancelPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    }
  },
data() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let roleId = userInfo.roleId;
    let isHospital = roleId == role.role_hospital;
    let serviceId = userInfo.useServiceId; 
    let progressList = this.getProgressList();
    var completedStatus = [
      requestStatus.completion,
      requestStatus.salesAppropriation,
      requestStatus.completionAppropriation
    ]
    progressList = progressList.filter( function(item){
        return item.code != '[' + requestStatus.deposit_regist + ']'; 
    });
    progressList = progressList.filter( function(item){
        return item.code != '[' + requestStatus.depositMachine + ']'; 
    });
    progressList = progressList.filter( function(item){
        return item.code != '[' + requestStatus.depositMachineReturnWait + ']'; 
    });
    progressList = progressList.filter( function(item){
        return item.code != '[' + requestStatus.depositMachineRelease + ']'; 
    });
    if(!this.isEnableService(serviceId, service.hst)){
      //HSTを行わないユーザーの場合は、「再検査調整中」を表示しない
      progressList = progressList.filter( function(item){
        return item.code != '[' + requestStatus.reInspection + ']'; 
      });
    }
    if(!this.isEnableService(serviceId, service.psg)){
      //PSG解析を行わないユーザーの場合は、「差換え依頼中」を表示しない
      progressList = progressList.filter( function(item){
        return item.code != '[' + requestStatus.replaceFile + ']'; 
      });
    }
    let kindList = this.getKindGroup()
    let hstModelList = this.getChoiceList(choicesType.hstKind, true);
    let preSearchConditions = this.$route.params["searchConditions"];
    //申込日のデフォルト値
    let applicationDateStartDate = new Date();
    applicationDateStartDate.setMonth(applicationDateStartDate.getMonth() - 6);
    let applicationDateStart = this.yyyy_hyp_MM_hyp_dd(applicationDateStartDate);
    let applicationDateEndDate = new Date();
    let applicationDateEnd = this.yyyy_hyp_MM_hyp_dd(applicationDateEndDate);
    return {
      service: service,
      serviceId: serviceId,
      isHospital: isHospital,
      choicesType:choicesType,
      data: [],
      isPaginated: true,
      isShowHstDetail: false,
      isShowPsgDetail: false,
      isShowKenshinDetail: false,
      isShowHolterDetail: false,
      isShowHolterAnalysisDetail: false,
      canUpdate: false,
      isComplete: false,
      fileListStr:"",
      targetRowData: {},
      isDownLoadFileList: false,
      dialogTopPostion: 0,
      belongsId:userInfo.belongsId,
      progressList,
      completedStatus,
      kindList,
      hstModelList: hstModelList,
      preSearchConditions,
      searchConditions:{
        receiptNumber:"",
        kind:[],
        progress:[],
        hospital:"",
        patientId:"",
        patientName:"",
        applicationDateStart:applicationDateStart,
        applicationDateEnd:applicationDateEnd,
        completionDateStart:"",
        completionDateEnd:"",
        downloadFlag:""
      },
      showDetailTargetData:{},
      showDetailTargetReceiptNumber:"",
      reset: 0,
      reSearchFlag:false,
      printTargetData:{},
      isPrintModalActive:false,
      printTargetReceiptNumber:"",
      printTargetReqDate:"",
      printType:"",
      printTitle:"",
      isAccommodations:false,
      requestCancel:false,
      version:null,
      reason:"",
      dataBlank: false
    };
  },
  filters: {},
  components: { 
    floatingDiv: floatingDiv,
    hstRequestDetail:HSTRequestDetail,
    psgRequestDetail:PSGRequestDetail,
    kenshinRequestDetail:KenshinRequestDetail,
    holterRequestDetail:HolterRequestDetail,
    holterAnalysisRequestDetail:HolterAnalysisRequestDetail,
    downLoadFileList:DownLoadFileList,
    FileListHospitalDialog,
  },
  mounted: function() {
    if(this.preSearchConditions){
      this.searchConditions = this.preSearchConditions;
      this.preSearchConditions = {}
      this.doSearch();
    }
  }
};
</script>
<style lang="scss" scoped>
.conditionTable th {
  width: 100px;
}
.conditionTable td {
  width: 400px;
}
a {
  text-decoration: underline;
}
.tag {
  width: 100px;
}

#item-contens table tr th {
  width: 70px;
}

#item-contens table tr td button {
  width: 165px;
  margin-right: 3px;
}
.button-group{
  margin-top:2px;
}
.file-dialog {
  z-index: 20;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/RequestFormList.vue